import React, { useEffect, useRef } from "react";
import { LoaderFunctionArgs, redirect, useLoaderData } from "react-router";
import { getOrder, getStripeOrder } from "../../lib/api";
import { IAPIResponse, IOrder } from "../../types/api";
import "../../assets/css/wibb/pages/register.scss";
import { useReactToPrint } from "react-to-print";
import OrderDetails from "../../components/OrderDetails";
import { Col, Container, Row } from "react-bootstrap";

export const loader = async ({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    const paymentIntent = url.searchParams.get("payment_intent");
    const orderId = url.searchParams.get("order_id");

    if (orderId) {
        return await getOrder(parseInt(orderId));
    } else if (paymentIntent) {
        return await getStripeOrder(paymentIntent);
    } else {
        return redirect("/");
    }
};
const ThankYou = (): React.JSX.Element => {
    const { paymentStatus, order } = useLoaderData() as IAPIResponse & {
        paymentStatus?: string;
        order: IOrder;
    };

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
        documentTitle: `Order #${order.id} Receipt`,
        onBeforePrint: () => console.log("before printing..."),
        onAfterPrint: () => console.log("after printing..."),
        removeAfterPrint: true,
        content: () => componentRef.current,
    });

    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if ((event.ctrlKey || event.metaKey) && event.key === "p") {
                event.preventDefault();
                handlePrint();
            }
        };

        window.addEventListener("keydown", handleKeydown);

        return () => {
            window.removeEventListener("keydown", handleKeydown);
        };
    }, [handlePrint]);

    let header = "";
    switch (paymentStatus) {
        case "succeeded":
            header = "Checkout complete!";
            break;
        case "proccessing":
            header = "Your payment is processing";
            break;
        default:
            header = "Thank you for your order";
            break;
    }

    return (
        <>
            <OrderDetails order={order} ref={componentRef} />
        </>
    );
};

export default ThankYou;
